import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_GET_REALESTATE_INVESTMENT } from "../../../config/api";
// import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const getREInvestments = createAsyncThunk(
  "getREInvestments/GET",
  async ({ currency, cb }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: `${API_GET_REALESTATE_INVESTMENT}${currency}`,
      });
      if (cb) cb();
      return data?.data;
    } catch (error) {
      // const msg = proccessErrorMessage(error);
    }
  }
);
